// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Traductions
const resources = {
  fr: {
    translation: {
      welcome: "Bienvenue sur notre site",
      cart: "Panier",
      switchLanguage: "العربية",
    },
  },
  ar: {
    translation: {
      welcome: "مرحبًا بكم في موقعنا",
      cart: "السلة",
      switchLanguage: "Français",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
